import { FC, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toolbar } from "./modules/navigation/Toolbar";
import { ScrollTop } from "../_metronic/layout/components/ScrollTop";
import { Content } from "../_metronic/layout/components/Content";
import { PageDataProvider } from "../_metronic/layout/core";
import { useThemeMode } from "../_metronic/partials/layout/theme-mode/ThemeModeProvider";
import { MenuComponent } from "../_metronic/assets/ts/components";
import { WithChildren } from "../_metronic/helpers";
import { HeaderNotifications } from "../_metronic/layout/components/header/HeaderNotifications";
import { AsideMenu } from "./modules/navigation/aside/AsideMenu";

const MasterLayout: FC<WithChildren> = () => {
  useThemeMode();
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization();
    }, 500);
  }, [location.key]);

  return (
    <PageDataProvider>
      <div className="page d-flex flex-row flex-column-fluid">
        <AsideMenu />
        <div
          className={
            "wrapper d-flex flex-column flex-row-fluid " +
            (location.pathname === "/dashboard" || location.pathname === "/powerbidashboard" ? "pt-0" : "")
          }
          id="kt_wrapper"
          style={{ minHeight: "100vh" }}
        >
          <Toolbar />
          <div id="kt_content" className="content d-flex flex-column flex-column-fluid">
            <HeaderNotifications />
            <div className="post d-flex flex-column-fluid mt-2" id="kt_post">
              <Content>
                <Outlet />
              </Content>
            </div>
          </div>
        </div>
      </div>
      <ScrollTop />
    </PageDataProvider>
  );
};

export { MasterLayout };
